import { ArrowUpRight, X } from "lucide-react";
import { Link } from "react-router-dom";
import { contactLocation, tableBooker } from "../../constants/routing";
import { Button } from "../ui/button";
import { siteNavItems } from "./site-nav";
import Logo from "../elements/logo";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileMenu({ isOpen, onClose }: MobileMenuProps) {
  return (
    <div
      className={[
        "fixed inset-0 z-40 bg-background/96 backdrop-blur-xl transition-all duration-300",
        isOpen ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0",
      ].join(" ")}
    >
      <div
        className={[
          "flex h-full flex-col transition-transform duration-300",
          isOpen ? "translate-x-0" : "translate-x-full",
        ].join(" ")}
      >
        <div className="flex h-20 items-center justify-between border-b border-border/60 px-4 sm:px-6">
          <div className="shrink-0">
            <Link to="/" onClick={onClose}>
              <Logo variant="dark" className="h-10 w-auto" />
            </Link>
          </div>
          <button
            onClick={onClose}
            className="rounded-full border border-border bg-card p-3 text-foreground transition-colors hover:border-primary/40 hover:text-primary"
            aria-label="Sluit navigatie"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="flex flex-1 flex-col justify-between overflow-y-auto px-4 py-8 sm:px-6">
          <nav className="space-y-3">
            {siteNavItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={onClose}
                className="flex items-center justify-between rounded-2xl border border-border/80 bg-card px-5 py-4 text-lg text-foreground transition-colors hover:border-primary/30 hover:text-primary"
              >
                <span>{item.label}</span>
                <ArrowUpRight className="h-4 w-4" />
              </Link>
            ))}
          </nav>

          <div className="mt-8 rounded-3xl border border-border/80 bg-card p-5 shadow-sm">
            <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Reserveren</p>
            <p className="mt-3 font-display text-3xl text-primary">Klaar voor een avond Italiaans tafelen?</p>
            <p className="mt-3 text-sm leading-6 text-muted-foreground">
              Boek online of neem contact op voor grotere gezelschappen en speciale gelegenheden.
            </p>
            <div className="mt-5 grid gap-3">
              <Button asChild className="bg-accent text-[#1f1a12] hover:bg-accent-dark">
                <a href={tableBooker} target="_blank" rel="noreferrer">
                  Online reserveren
                </a>
              </Button>
              <Button asChild variant="outline">
                <Link to={contactLocation} onClick={onClose}>
                  Contact & openingsuren
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
